module.exports = __webpack_public_path__ + "media/images/partners/bazaar-e7772a5e7f6e0d792382efb3f12a9b42.svg";